export { default } from './NumberSearch.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumberSearch/index.js